export var LimitScene;
(function (LimitScene) {
    LimitScene["Publish"] = "publish";
    LimitScene["Flow"] = "flow";
})(LimitScene || (LimitScene = {}));
export const isConfiguredDisable = (scene) => window.GLOBAL_INFO.trialVersion?.limits?.[scene]?.disabled;
